export default __webpack_public_path__ + "static/google-review-white-438a0fb1ddf2bbc00c596fcc35fa61d2.svg";